import {
  Box,
  VStack,
  HStack,
  Icon,
  Divider,
  Text,
  Button,
  Heading,
  Image,
  AspectRatio,
} from '@chakra-ui/react';

import Content from '~/containers/Content';
import PageContainer from '~/containers/PageContainer';
import OperatingTimeList from '~/components/OperatingTimeList';
import SectionLabel from '~/components/SectionLabel';

import { IoTimeOutline, IoCallOutline } from 'react-icons/io5';
import { AiOutlineShop, AiOutlineEnvironment } from 'react-icons/ai';
import { useNavigate, useParams } from 'react-router-dom';

import { BtnVariant } from '~/theme/components/Button';
import LocationBar from '~/components/LocationBar';
import BackwardBar from '~/components/BackwardBar';

import useSingleReturnContainerPoint from '../hooks/useSingleReturnContainerPoint';
import tzuchiDefaultImg from '~/assets/images/defaultImage.png';

export default function LocationInfo() {
  const { locationId = '' } = useParams();
  const navigate = useNavigate();
  const { isInit, returnContainerPoint } = useSingleReturnContainerPoint(locationId);

  if (isInit && !returnContainerPoint) {
    navigate('/mealBoxRecycling');
  }
  if (!returnContainerPoint) {
    return <></>;
  }

  return (
    <PageContainer
      hideHeader
      hideNavBar
      afterHeaderComponent={
        <>
          <BackwardBar title="返回" onNavigate={() => navigate(-1)} />
          <LocationBar
            rightHandComponent={
              <Text fontSize="xs" color="white">
                你所選的取餐地點
              </Text>
            }
          />
        </>
      }
    >
      <Box as="main" bg="white">
        <Box as="section" bg="white" px={4} borderBottomColor="primary" borderBottomWidth="2px">
          <Content m="auto">
            <HStack py={2}>
              <Heading size="sm" letterSpacing={1.5}>
                還餐盒地點詳情頁
              </Heading>
            </HStack>
          </Content>
        </Box>
        <Content>
          <AspectRatio ratio={3 / 2}>
            <Image objectFit="cover" src={returnContainerPoint.image || tzuchiDefaultImg} />
          </AspectRatio>
        </Content>

        <Content m="auto" p={4}>
          <VStack align="stretch" spacing={4} divider={<Divider />}>
            <VStack align="flex-start" py={2}>
              <Heading size="sm">{returnContainerPoint.name}</Heading>
              <HStack>
                <Icon as={IoCallOutline} boxSize="1.125rem" color="gray.500" />
                <Text fontSize="sm">{returnContainerPoint.phoneNumber}</Text>
              </HStack>
              <HStack>
                <Icon as={AiOutlineEnvironment} boxSize="1.125rem" color="gray.500" />
                <Text fontSize="sm">{returnContainerPoint.location.address}</Text>
              </HStack>
              <Button
                variant={BtnVariant.OUTLINE}
                size="sm"
                color="primary"
                borderColor="primary"
                px={1}
                _hover={{
                  borderColor: 'primaryLight',
                  bg: 'primaryLight',
                  color: 'white',
                }}
                fontWeight="normal"
                leftIcon={<Icon as={AiOutlineEnvironment} boxSize="1.125rem" />}
                onClick={() =>
                  window.open(
                    `https://maps.google.com/?q=${returnContainerPoint.location.geoPoint.latitude},${returnContainerPoint.location.geoPoint.longitude}`,
                  )
                }
              >
                查看地圖
              </Button>
            </VStack>
            <VStack align="stretch">
              <SectionLabel icon={AiOutlineShop} title="位置描述" />
              <Text fontSize="sm">{returnContainerPoint.description}</Text>
            </VStack>
            <VStack align="stretch" spacing={3}>
              <SectionLabel icon={IoTimeOutline} title="營業時間" />
              <OperatingTimeList operatingTime={returnContainerPoint.schedule} />
            </VStack>
          </VStack>
        </Content>
      </Box>
    </PageContainer>
  );
}
